import React, { useState, useEffect } from "react";
import Layout from "../../../components/template/Layout";
import LogoutModal from "../../../components/template/Modal/LogoutModal";
import {
  isOfflineMode as getOfflineMode,
  turnOfflineModeOn,
  turnOfflineModeOff,
  onOfflineModeChange,
} from "../../../shared/offlineManager";

const Settings: React.FC = () => {
  const [isOfflineMode, setIsOfflineMode] = useState(() => getOfflineMode());
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [storageInfo, setStorageInfo] = useState<{
    used: string;
    available: string;
    percentage: string;
  } | null>(null);

  useEffect(() => {
    const unsubscribe = onOfflineModeChange(setIsOfflineMode);
    checkStorageLimits();

    return unsubscribe;
  }, []);

  const handleOfflineModeToggle = () => {
    if (isOfflineMode) {
      turnOfflineModeOff();
    } else {
      turnOfflineModeOn();
    }
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const checkStorageLimits = async () => {
    if ("storage" in navigator && "estimate" in navigator.storage) {
      const { usage, quota } = await navigator.storage.estimate();

      if (usage && quota) {
        // Convert to more readable format
        const usedGB = (usage / 1024 / 1024 / 1024).toFixed(2);
        const availableGB = (quota / 1024 / 1024 / 1024).toFixed(2);
        setStorageInfo({
          used: usedGB,
          available: availableGB,
          percentage: ((usage / quota) * 100).toFixed(2),
        });
      }
    } else {
      console.log("Storage API not supported");
      return null;
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Layout title="Settings" showBackIcon={true}>
        <div className=" w-full p-4">
          <div className="bg-white rounded-lg w-full">
            <div className="text-textPrimary text-md">
              {/* <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Nuke Debug History')}>
                            <span>Nuke Debug History</span>
                            <img src={ASSET_PATHS.nuke} alt="Progress" />

                        </div>

                        <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Nuke Local Work Orders')}>
                            <span>Nuke Local Work Orders</span>
                            <img src={ASSET_PATHS.nuke} alt="Progress" />
                        </div>

                        <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Nuke All Media')}>
                            <span>Nuke All Media</span>
                            <img src={ASSET_PATHS.nuke} alt="Progress" />
                        </div> */}
            </div>

            {/* Offline Mode Toggle */}
            <div className="border-t p-3">
              <div className="flex items-center justify-between">
                <div>
                  <span className="text-textPrimary">Offline Mode</span>
                  <div className="text-sm text-gray-500 mt-1">
                    You are currently {isOfflineMode ? "offline" : "online"}
                  </div>
                </div>
                <button
                  onClick={handleOfflineModeToggle}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${
                    isOfflineMode ? "bg-primary" : "bg-gray-200"
                  }`}
                  role="switch"
                  aria-checked={isOfflineMode}
                  aria-label="Toggle offline mode"
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      isOfflineMode ? "translate-x-6" : "translate-x-1"
                    }`}
                  />
                </button>
              </div>
            </div>

            {/* Logout Option */}
            <div className="border-t p-3">
              <div
                className="flex items-center justify-between cursor-pointer"
                onClick={handleLogout}
              >
                <div className="flex items-center space-x-3">
                  <span className="text-red-500">Logout</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-3">
          <div className="">
            <div className="flex items-center space-x-3">
              <span className="text-textPrimary border-b border-gray-200">Storage</span>
            </div>
            <div className="text-sm text-gray-500 mt-1">
              Used: {storageInfo?.used}GB
            </div>
            <div className="text-sm text-gray-500 mt-1">
              Available: {storageInfo?.available}GB
            </div>
          </div>
        </div>
      </Layout>

      {/* Logout Modal */}
      {showLogoutModal && (
        <LogoutModal
          onClose={() => setShowLogoutModal(false)}
          isOpen={showLogoutModal}
        />
      )}
    </div>
  );
};

export default Settings;
